import { Fragment, ReactNode } from 'react';

import { Box, Flex, Headings, Line, Text } from '@foradevelopment/fora-ui';
import { getReadableTimestamp } from '@fora-monorepo/date-utils';

type HistoryLogListProps = {
  title: string;
  children: ReactNode;
};

export const HistoryLogList = ({ title, children }: HistoryLogListProps) => {
  return (
    <Box backgroundColor="white">
      <Headings.H5>{title}</Headings.H5>
      <Line color="black20" marginTop={20} marginBottom={10} />
      {children}
    </Box>
  );
};

type HistoryLogItemProps = {
  children: ReactNode;
  date: string;
  index: number;
};

export const HistoryLogItem = ({ children, date, index }: HistoryLogItemProps) => {
  return (
    <Fragment key={`history-log-key-${index}`}>
      <Flex columnGap={40} rowGap={6} flexWrap="wrap">
        <Text size="small">{getReadableTimestamp(date)}</Text>
        <Box flexBasis={['100%', 0, 0]} flexGrow={1}>
          {children}
        </Box>
      </Flex>
      <Line color="black20" marginTop={10} marginBottom={10} />
    </Fragment>
  );
};
